import { TypographyVariant } from '../../theming';

export const barWidth = 24;
export const barSpacing = 6;
export const pixelsPerDegree = 4;
export const labelClearance = 8;
export const topBuffer = 20;
export const activeBarHeightBuffer = 26;
export const legendHeight = 66;
export const legendValueBottomClearance = 70;
export const legendSeparatorClearance = legendValueBottomClearance - 25;
export const legendSeparatorHeight = 46;
export const legendValueLabelClearance = 18;
export const barLabelClearance = 16;

export const BAR_LABEL_FONT_VARIANT: TypographyVariant = 'body.s';
